import React from "react";
import Features from "../Features";
import "./index.css";

export default function Resources({
    pageDetails = {},
    isEditing,
    onChange
}) {

    const {
        header = "What Our Platform Provides",

        featuresData = {
            features: [
                "Improved counterparty risk assessment",
                "Stronger AML regulatory compliance",
            ],

            identifiers: [
                "UEI",
                "CUSIP",
            ]
        }

    } = pageDetails;

    // ✅ HEADER UPDATE
    const updateHeader = (value) => {

        onChange({
            ...pageDetails,
            header: value
        });
    };

    // ✅ FEATURES UPDATE
    const updateFeatures = (updated) => {

        onChange({
            ...pageDetails,

            featuresData: {
                features:
                    updated.features || [],

                identifiers:
                    updated.identifiers || []
            }
        });
    };

    return (
        <section className="benefits-section">

            <div className="tb-header">

                {/* HEADER */}
                {isEditing ? (

                    <input
                        placeholder="Section Header"
                        className="demo-input small"
                        value={header}
                        onChange={(e) =>
                            updateHeader(
                                e.target.value
                            )
                        }
                    />

                ) : (

                    <h2 className="benefits-heading">
                        {header}
                    </h2>

                )}

                {/* FEATURES */}
                <Features
                    data={featuresData}
                    isEditing={isEditing}
                    onChange={updateFeatures}
                />

            </div>
        </section>
    );
}